import React from 'react';
import {useTranslation} from 'react-i18next';
import XIcon from '../../../../assets/icons/XIcon';
import * as css from './QrZoomClose.css';

interface QrZoomCloseProps {
    reduceMotion: boolean | null;
    onClose: () => void;
}

function QrZoomClose({reduceMotion, onClose}: QrZoomCloseProps): React.ReactElement {
    const {t} = useTranslation('eTicket');

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClose();
    };

    return (
        <css.closeBtn
            type="button"
            initial={{y: 100, opacity: 0, x: '-50%'}}
            animate={{y: 0, opacity: 1, x: '-50%'}}
            transition={{
                y: {
                    duration: reduceMotion ? 0 : 0.6,
                    ease: [0.175, 0.885, 0.32, 1.275],
                    delay: reduceMotion ? 0 : 0.15,
                },
                opacity: {
                    duration: reduceMotion ? 0 : 0.2,
                    ease: [0.25, 0.1, 0.25, 1],
                    delay: reduceMotion ? 0 : 0.15,
                },
            }}
            onClick={handleClick}
            aria-label={t('qrClose')}
            data-cy="qr-zoom-close"
        >
            <XIcon color="var(--color-icon-default)" width={24} height={24} />
        </css.closeBtn>
    );
}

export default QrZoomClose;
